import { Monitor, Plus } from 'lucide-react'

interface DeviceInventoryEmptyStateProps {
  onAddDevices?: () => void
}

export const DeviceInventoryEmptyState = ({ onAddDevices }: DeviceInventoryEmptyStateProps) => {
  return (
    <div className="bg-white rounded-2xl border-gray-100 border-4">
      {/* Table Headers */}
      <div className="px-6 py-4 border-b border-gray-200 mb-6">
        <div className="grid grid-cols-5 gap-4 text-xs font-medium text-[#6B7C94] uppercase tracking-wider">
          <div>Display Name</div>
          <div>Type</div>
          <div>Status</div>
          <div>Logged-In User</div>
          <div>Last Active</div>
        </div>
      </div>

      {/* Empty State */}
      <div className="text-center py-8">
        <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <Monitor className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          No Devices Yet
        </h3>
        <p className="text-gray-400 text-sm max-w-md mx-auto mb-6">
          Get started by adding your first device or deploying agents to automatically discover and monitor your IT infrastructure.
        </p>
        {onAddDevices && (
          <button
            onClick={onAddDevices}
            className="inline-flex items-center px-4 py-3 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add New Devices
          </button>
        )}
      </div>
    </div>
  )
}
